import { Alert, AlertDescription, AlertIcon } from '@chakra-ui/react';
import * as React from 'react';

export const TokboxNotFound: React.FC = () => {
  return (
    <Alert status="error">
      <AlertIcon />
      <AlertDescription>
        Livestream video option is no longer available
      </AlertDescription>
    </Alert>
  );
};
